"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M27.3 28.067a35.984 35.984 0 0 1-.96-6.329 12.019 12.019 0 0 1 .761-3.6c2.969-1.06 4.52-3.8 4.52-7.025A7.5 7.5 0 0 0 24 3.613a7.479 7.479 0 0 0-7.6 7.5c0 3.219 1.534 5.956 4.5 7.02a12.6 12.6 0 0 1 .775 3.6 37.661 37.661 0 0 1-.968 6.33c-4.447.222-11.794 2.187-14.8 3.229A2.81 2.81 0 0 0 4 33.948v3.039a1 1 0 0 0 1 1h38a1 1 0 0 0 1-1v-3.038a2.81 2.81 0 0 0-1.9-2.649c-3.012-1.047-10.354-3.012-14.8-3.233z" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "36", x: "6", y: "40" })
);

